import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Lodinging from "../components/loading";
import Postread from '../job_task_root/postread';
import Skillscategories from '../jobcategories/skillscategories';
import Categories from '../jobcategories/categories';
import Home from '../home_root/home';
import Companiesprofile from '../companys_root/companiesprofile';
import Userprofile from '../profile_root/userprofile';
import Feedview from '../feed_root/feed-view';
import Workstation from '../workstation_root/workstation';
import UpdateItemStatus from '../workstation_root/item_root/update-item-status';
export default function Idpage() {
  const { id } = useParams();
  const [feedData, setFeedData] = useState(null);
  const [postData, setPostData] = useState(null);
  const [skillscategoriesData, setSkillscategoriesData] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [projectdata, setProjectdata] = useState([]);
  const [updateitemdata, setUpdateitemdata] = useState([]);
  const [userprofileData, setUserprofileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Reset all
        setUpdateitemdata(null);
        setProjectdata(null);
        setFeedData(null);
        setPostData(null);
        setSkillscategoriesData(null);
        setCategoryData(null);
        setCompanyData(null);
        setLoading(true);
        setError(false);
        // Check in feedsdata
        const pQuery = query(collection(db, "projects"), where("puid", "==", id), where("status", "==", true));
        const pSnap = await getDocs(pQuery);
        if (!pSnap.empty) {
          const doc = pSnap.docs[0].data();
          if (doc?.status === true) {
            // document.title = doc.title + "| EditorTask.com";
            setProjectdata({ ...doc, puid: pSnap.docs[0].id });
          }
        }
        // item update status
        const iQuery = query(
          collection(db, "projectstaskitem"),
          where("itemuid", "==", id),
          where("status", "==", true)
        );

        const iSnap = await getDocs(iQuery);

        if (!iSnap.empty) {
          const docData = iSnap.docs[0].data();
          const docId = iSnap.docs[0].id;

          if (docData?.status === true) {
            document.title = `${docData.itemname} | EditorTask.com`;

            // Add the document ID to the data and update state
            setUpdateitemdata({
              ...docData,
              itemuid: docId,
            });
          }
        }
        // Check in feedsdata
        const feedQuery = query(collection(db, "feeddata"), where("slug", "==", id), where("public", "==", true));
        const feedSnap = await getDocs(feedQuery);
        if (!feedSnap.empty) {
          const doc = feedSnap.docs[0].data();
          if (doc?.status === true) {
            // document.title = doc.title + "| EditorTask.com";
            setFeedData({ ...doc, uid: feedSnap.docs[0].id });
          }
        }

        // Check in postdata
        const postQuery = query(collection(db, "postdata"), where("slug", "==", id), where("visibility", "==", true));
        const postSnap = await getDocs(postQuery);
        if (!postSnap.empty) {
          const doc = postSnap.docs[0].data();
          if (doc?.status === true) {
            document.title = doc.title;
            setPostData({ ...doc, uid: postSnap.docs[0].id });
          }
        }
        // Check in skillscategories
        const skillsQuery = query(collection(db, "skills_categories"), where("slug", "==", id));
        const skillsSnap = await getDocs(skillsQuery);
        if (!skillsSnap.empty) {
          const doc = skillsSnap.docs[0].data();
          if (doc?.status === true) {
            document.title = doc.title;
            setSkillscategoriesData({ ...doc, uid: skillsSnap.docs[0].id });
          }
        }
        // Check in jobcategories
        const catQuery = query(collection(db, "jobcategories"), where("slug", "==", id));
        const catSnap = await getDocs(catQuery);
        if (!catSnap.empty) {
          const doc = catSnap.docs[0].data();
          if (doc?.status === true) {
            document.title = doc.title;
            setCategoryData({ ...doc, uid: catSnap.docs[0].id });
          }
        }
        // Check in companys
        const companyQuery = query(collection(db, "companys"), where("slug", "==", id));
        const companySnap = await getDocs(companyQuery);
        if (!companySnap.empty) {
          const doc = companySnap.docs[0].data();
          if (doc?.status === true) {

            document.title = doc.companyname;
            setCompanyData({ ...doc, uid: companySnap.docs[0].id });
          }
        }
        // Check in profile
        const userprofileQuery = query(collection(db, "users"), where("slug", "==", id));
        const userprofileSnap = await getDocs(userprofileQuery);
        if (!userprofileSnap.empty) {
          const doc = userprofileSnap.docs[0].data();
          if (doc?.status === true) {
            document.title = doc.name;
            setUserprofileData({ ...doc, uid: userprofileSnap.docs[0].id });
          }
        }
      } catch (err) {
        console.error("Error:", err);
        setError(true);
      } finally {
        setLoading(false); // ✅ ALWAYS call this at the end
      }
    };

    if (id) fetchData();
  }, [id]);

  // 🔁 Render Logic
  if (loading) {
    return <div className="container_roots"><Lodinging /></div>;
  }
  if (projectdata) return <Workstation data={projectdata} />;
  if (updateitemdata) return <UpdateItemStatus data={updateitemdata} />;
  if (feedData) return <Feedview data={feedData} />;
  if (postData) return <Postread data={postData} />;
  if (skillscategoriesData) return <Skillscategories data={skillscategoriesData} />;
  if (categoryData) return <Categories data={categoryData} />;
  if (companyData) return <Companiesprofile data={companyData} />;
  if (userprofileData) return <Userprofile data={userprofileData} />;
  if (error) return <Home />;

  return <Home />;
}
